<template>
  <div class="selected-item-card">
    <img
      src="@/resources/images/chat_icon.svg"
      loading="lazy"
      class="item-avatar"
      alt="Live chat icon"
    />
    <div class="item-info">
      <h2 class="title custPadding">Start Live Chat</h2>
    </div>
    <VIcon name="delete-line" connotation="alert" class="trashIcon cursorPointer" @click="emit('clear')"></VIcon>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  clear: []
}>();
</script>

<style scoped>
.selected-item-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--background-primary);
  border-radius: 5px;
  padding: 12px 16px;
  margin-top: 20px;
}
.item-avatar {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  flex-shrink: 0;
}
.item-info {
  flex: 1;
}
.custPadding {
  padding-bottom: 5px;
}
</style>
